import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptService {
  password : string = "hola";

  constructor() {
  }

  encrypt(data: any){
    return (CryptoJS.AES.encrypt(JSON.stringify(data), this.password).toString())
  }

  decrypt(data: any){
    return (JSON.parse(CryptoJS.AES.decrypt(data, this.password).toString(CryptoJS.enc.Utf8)))
  }

}
